import useReferralCapture from "../hooks/useReferralCapture";

/* Renders nothing; lives inside the Router so it can read ?ref= on any page. */
const ReferralCapture = () => {
  useReferralCapture();
  return null;
};

export default ReferralCapture;
